import React, {useMemo} from 'react';
import styled from "styled-components";
import ChampionImageWithLane from "../common/ChampionImageWithLane";
import useGetChampionSpells from "../../common/hooks/useGetChampionSpells";
import useChampionFunc from "../../common/hooks/useChampionFunc";
import ChampionSkillImage from "../common/ChampionSkillImage";
import {useSelector} from "react-redux";
import {getIndexSpellText} from "../../function";
import ChampionPassiveImage from "../common/ChampionPassiveImage";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: ${props => {
    let items = 'flex-start';
    if (props.reverse) {
      items = 'flex-end'
    }
    return items;
  }};
`;
const ChampionName = styled.span`
  font-weight: 700;
  font-size: 24px;
  color: ${props => props.theme.color.dark_100};
`;
const ChampionNameSmall = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: ${props => props.theme.color.dark_300};
`;

const CounterPickWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: ${props => {
    let items = 'flex-start';
    if (props.reverse) {
      items = 'flex-end'
    }
    return items;
  }};
`;
const CounterPickText = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
`;

const ChampionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
`;
const ChampionBox = styled.div`
  border-radius: 100%;
  border: 2px solid ${props => props.theme.color.green_100};
  cursor: pointer;
  width: 34px;
  height: 34px;

  .imgDiv {
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }

  .imgChamp {
    width: 34px;
    height: 34px;
  }

`;
const EmptyChampion = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 100%;
  border: 2px solid ${props => props.theme.color.default_border_color};
`;

const ChampionNameSmallWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  height: 19px;
`;
const ChampionNameWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 29px;
`;


const LlmChampionCounter = ({champion, reverse, championBuild, onChangeChampion, position}) => {
const {t} = useTranslation()

    if (!champion?.champion_name) {
        return (
            <Wrapper reverse={reverse}>
                <ChampionNameWrapper>
                    <ChampionName>-</ChampionName>
                </ChampionNameWrapper>
                <ChampionNameSmallWrapper>
                    <ChampionNameSmall>-</ChampionNameSmall>
                </ChampionNameSmallWrapper>
                <CounterPickWrapper reverse={reverse}>
                    <CounterPickText>
                        {t('llm.against')}
                    </CounterPickText>
                    <ChampionWrapper>
                        <EmptyChampion/>
                        <EmptyChampion/>
                        <EmptyChampion/>
                        <EmptyChampion/>
                        <EmptyChampion/>
                    </ChampionWrapper>
                </CounterPickWrapper>
            </Wrapper>
        )
    }

    return (
        <RenderItem champion={champion} onChangeChampion={onChangeChampion} championBuild={championBuild}
                    reverse={reverse} position={position}/>
    );
};


const RenderItem = ({champion, reverse, championBuild, onChangeChampion, position}) => {
    const {t} = useTranslation()
    const version = useSelector((state) => state?.gameVersion.version);
    const {getUrlNameById} = useChampionFunc();
    const champName = getUrlNameById(champion?.champion_id);
    const skillList = useGetChampionSpells(champName);
    const counterPick = useMemo(() => {
        try {
            return championBuild.match_up.weak_against.slice(0, 5)
        } catch (e) {
            return []
        }
    }, [championBuild, position]);


    return (
        <Wrapper reverse={reverse}>
            <ChampionNameWrapper>
                <ChampionName>{champion?.champion_name}</ChampionName>
            </ChampionNameWrapper>
            <ChampionNameSmallWrapper>
                <ChampionNameSmall>{champion?.champion_name_en}</ChampionNameSmall>
            </ChampionNameSmallWrapper>
            <CounterPickWrapper reverse={reverse}>
                <CounterPickText>
                    {t('llm.against')}
                </CounterPickText>
                <ChampionWrapper>
                    {Array.from({length: 5}).map((_, index) => {
                        const item = counterPick?.[index]
                        if (!item) {
                            return <EmptyChampion key={index + "emepyChamp"}/>
                        }
                        return (
                            <ChampionBox key={item.enemy_champion_id}
                                         onClick={() => onChangeChampion(item.enemy_champion_id)}>
                                <ChampionImageWithLane champion_id={item.enemy_champion_id} disabled={true}/>
                            </ChampionBox>
                        )
                    })}
                </ChampionWrapper>
            </CounterPickWrapper>

            <CounterPickWrapper reverse={reverse}>
                <CounterPickText>
                    {t('llm.skill')}
                </CounterPickText>
                <ChampionWrapper>
                    {skillList?.passive?.image?.full ?
                        <ChampionPassiveImage
                            reverse={true}
                            version={version}
                            width={32}
                            height={32}
                            img={skillList?.passive?.image?.full}
                            tooltip={`<span style="font-weight: 500; color: #46B9AA;">${skillList?.passive?.name}</span>\n${skillList?.passive?.description}`}
                        />
                        :
                        null}
                    {skillList?.spells?.map((data, index) => {
                        return (
                            <ChampionSkillImage
                                key={index}
                                reverse={true}
                                width={32}
                                height={32}
                                spell={data}
                                version={version}
                                absoluteText={getIndexSpellText(index)}
                                img={data?.image?.full}

                            />
                        )
                    })}

                </ChampionWrapper>
            </CounterPickWrapper>

        </Wrapper>
    )
}

export default React.memo(LlmChampionCounter);